import { useQuery } from '@tanstack/react-query';

import { getBunkerStops } from '../../common/api/clients/bunkerPlan.api';
import { queryKeys } from '../../common/api/queryKeys';

export const useBunkerStops = () => {
    return useQuery({ queryKey: queryKeys.bunkerStops(), queryFn: () => getBunkerStops() });
};
